// extracted by mini-css-extract-plugin
module.exports = {"overlayMenuTabs":"OverlayMenuTabs_overlayMenuTabs__9qkY1"};